import { useSubscription } from '@/hooks/useSubscription'
import { Link } from 'react-router-dom'
import { AlertTriangle, Clock, X, Sparkles } from 'lucide-react'
import { useState } from 'react'

export function TrialBanner() {
  const { isTrial, trialDaysRemaining, isTrialExpired, loading } = useSubscription()
  const [dismissed, setDismissed] = useState(false)

  if (loading || dismissed) return null

  // Show expired banner
  if (isTrialExpired) {
    return (
      <div className="bg-red-600 text-white px-4 py-3">
        <div className="container mx-auto flex items-center justify-between">
          <div className="flex items-center gap-2">
            <AlertTriangle className="h-4 w-4" />
            <span className="text-sm font-medium">
              Your free trial has ended. Subscribe to continue using all features.
            </span>
          </div>
          <Link
            to="/pricing"
            className="rounded-md bg-white px-3 py-1 text-sm font-medium text-red-600 hover:bg-red-50 transition-colors"
          >
            Subscribe Now
          </Link>
        </div>
      </div>
    )
  }

  // Show urgent countdown when < 3 days remaining
  if (isTrial && trialDaysRemaining <= 3 && trialDaysRemaining > 0) {
    return (
      <div className="bg-amber-500 text-white px-4 py-3">
        <div className="container mx-auto flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Clock className="h-4 w-4" />
            <span className="text-sm font-medium">
              {trialDaysRemaining === 1
                ? 'Your trial ends tomorrow! Subscribe now to keep all your data.'
                : `Your trial ends in ${trialDaysRemaining} days. Subscribe to keep access.`}
            </span>
          </div>
          <div className="flex items-center gap-2">
            <Link
              to="/pricing"
              className="rounded-md bg-white px-3 py-1 text-sm font-medium text-amber-600 hover:bg-amber-50 transition-colors"
            >
              Choose a Plan
            </Link>
            <button onClick={() => setDismissed(true)} className="p-1 hover:bg-amber-600 rounded">
              <X className="h-4 w-4" />
            </button>
          </div>
        </div>
      </div>
    )
  }

  // Always show trial status banner during active trial
  if (isTrial && trialDaysRemaining > 0) {
    return (
      <div className="bg-certify-600 text-white px-4 py-2.5">
        <div className="container mx-auto flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Sparkles className="h-4 w-4" />
            <span className="text-sm font-medium">
              Free Trial — {trialDaysRemaining} {trialDaysRemaining === 1 ? 'day' : 'days'} remaining with full Professional access
            </span>
          </div>
          <div className="flex items-center gap-2">
            <Link
              to="/pricing"
              className="rounded-md bg-white/20 px-3 py-1 text-sm font-medium hover:bg-white/30 transition-colors"
            >
              View Plans
            </Link>
            <button onClick={() => setDismissed(true)} className="p-1 hover:bg-certify-700 rounded">
              <X className="h-4 w-4" />
            </button>
          </div>
        </div>
      </div>
    )
  }

  return null
}
